import createSvgIcon from '../Utils/CreateSvgIcon';

export const Bonus = createSvgIcon(
  <>
    <path
      d="M8.016 7.743c-1.48-.025-2.39-1.63-1.65-2.913.74-1.282 2.586-1.298 3.347-.028L11.511 7.8l-3.495-.057ZM15.984 7.743c1.48-.025 2.39-1.63 1.65-2.913-.74-1.282-2.586-1.298-3.347-.028L12.489 7.8l3.495-.057ZM5 12h14v8H5zM4 8h16v4H4z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M11 9h2v10h-2z" />
  </>,
  'Bonus',
);
